<template lang="pug" src="./client-details.pug"></template>
<style lang="scss" src="./client-details.scss" scoped></style>

<script>
import orderTable from '../order-table';
import searchField from '@/components/search-field';
import { mapState } from 'vuex';
import { normalizedPhone } from "@/utils/helpers";

export default {
    components: {
        'v-order-table': orderTable,
        'v-search-field': searchField
    },
    data: () => ({
        showFpClientInfo: false,
        isSearchEnabled: false,
        phoneNumber: null
    }),
    computed: {
        ...mapState({
            orderHistories: state => state.orders.orderHistories,
            clientInfo: state => state.technicalSupport.clientInfo,
            fpClientInfo: state => state.technicalSupport.fpClientInfo,
            cardPhoneNumber: state => state.technicalSupport.cardData  && state.technicalSupport.cardData.phoneNumber
        }),
        showBonuses() {
            return this.clientInfo.bonusSystem
                && Object.keys(this.clientInfo.bonusSystem).length
                && !this.showFpClientInfo;
        },
        showCorporation() {
            return this.clientInfo.company
                && Object.keys(this.clientInfo.company).length
                && !this.showFpClientInfo;
        },
        showCashback() {
            const cashback = this.fpClientInfo.cashback;

            return cashback && cashback.group && !Object.isEmpty(cashback.group) && this.showFpClientInfo;
        },
        balanceHistoryHeaders() {
            return ['id', 'taxiOrderId', 'paymentId', 'change', 'balance', 'paymentType', 'createdAt'].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.TechnicalSupport.additionalInfo.fpBalanceHistoryTable.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        clientInfoLoaded() {
            return Object.values(this.clientInfo).some(it => Array.isArray(it) ? !!it.length : !!it);
        },
        canLoadFpData() {
            return this.phoneNumber && this.clientInfoLoaded;
        }
    },
    watch: {
        phoneNumber(value) {
            this.isSearchEnabled = !!value;
        },
        cardPhoneNumber(value) {
            if (value) {
                this.phoneNumber = value;
            }
        }
    },
    methods: {
        getClientInfo() {
            this.resetClientInfo();

            this.$store.dispatch('technicalSupport/getClientInfo', normalizedPhone(this.phoneNumber));
        },
        getFpClientInfo() {
            if (!this.showFpClientInfo) {
                this.$store.commit('technicalSupport/RESET_FP_CLIENT_INFO');
                return;
            }

            this.$store.dispatch('technicalSupport/getFpClientInfo', {
                phoneNumber: normalizedPhone(this.phoneNumber)
            })
                .then(res => {
                    if (res && res.status !== 200) {
                        this.showFpClientInfo = false;
                    }
                });
        },
        infoTranslation(type) {
            const translationPath = `$vuetify.pages.TechnicalSupport.additionalInfo.${type}`;
            const translationParams = [];

            const { bonusSystem, company } = this.clientInfo;

            if (type === 'bonuses' && bonusSystem) {
                const isActive = this.$vuetify.lang.t(`$vuetify.bonusSystem.${bonusSystem.isActive }`);
                translationParams.push(...[bonusSystem.title, isActive]);
            } else if (type === 'corporation' && company) {
                translationParams.push(company.title);
            }

            return this.$vuetify.lang.t(translationPath, ...translationParams);
        },
        resetClientInfo() {
            this.$store.commit('technicalSupport/RESET_CLIENT_INFO');
            this.$store.commit('technicalSupport/RESET_FP_CLIENT_INFO');
            this.showFpClientInfo = false;
        }
    }
};
</script>
